<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">支付通道管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="">
                <el-button size="small" type="primary" @click="addpayment">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table size="small" :data="listData" max-height="600" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column  prop="name" label="支付通道" align="center" ></el-table-column>
            <el-table-column  prop="commission" label="通道费用" align="center" ></el-table-column>
            <el-table-column  prop="payCode" label="编码" align="center" ></el-table-column>
            <el-table-column  prop="status" label="状态" align="center" >
                <template slot-scope="scope">
                    <span v-if="scope.row.status == 0">未开通</span>
                    <span v-if="scope.row.status == 1">已开通</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                <el-button size="mini" type="text" v-if="scope.row.status == 0" @click="openClick(scope.row)">开通</el-button>
                <el-button size="mini" type="text" @click="handleEdit(scope.row)">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->
        <!-- 新增 -->
        <el-dialog :visible.sync="editFormVisible" width="30%" @click="closeDialog">
            <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
                <el-form-item label="支付通道" prop="name">
                    <el-input size="small" v-model="editForm.name" style="width:230px" auto-complete="off" placeholder="请输入通道名称"></el-input>
                </el-form-item>
                <el-form-item label="通道费用" prop="commission">
                    <el-input size="small" v-model="editForm.commission" style="width:230px" auto-complete="off" placeholder="请输入通道费用"></el-input>
                </el-form-item>
                <el-form-item label="编码" prop="payCode">
                    <el-input size="small" v-model="editForm.payCode" style="width:230px" auto-complete="off" placeholder="请输入通道费用"></el-input>
                </el-form-item>
                
                <!-- <el-form-item label="状态">
                    <el-input size="small" v-model="editForm.phone" style="width:230px" auto-complete="off" placeholder="请输入部门代码"></el-input>
                </el-form-item> -->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
            </div>
        </el-dialog>
</div>
</template>
<script>
import Pagination from '../../../components/Pagination'
import { loadPayChannelList , savePayChannel } from '../../../api/userMG'
export default {
    data(){
        return{
            bindingFlag:false,
            activeName:"information",
            detailsFlag:false,
            options:[
                {
                value: '1',
                label: '上架'
                }, {
                value: '0',
                label: '下架'
                },
            ],
            editForm:{},
            editFormVisible:false,
            formInline: {
                page: 1,
                limit: 10,
                phone: '',
                name: '',
            },
            machineData:[],
            listData: [{
                url:'https://thirdwx.qlogo.cn/mmopen/vi_32/8kKUTuTsoibsLSHPAXfUAjX7zPssdyWk8CorQicic8gzHHuu517RcdXEhKFtIqvNyR0APLeyPiaqn6iaGfWzJp4Er5Q/132',
                sort:'1',
                status:0,
            }], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            rules: {
                name: [
                { required: true, message: '请输入通道名称', trigger: 'blur' }
                ],
                commission:[
                    { required: true, message: '请输入通道费用', trigger: 'blur' }
                ],
                payCode:[
                    { required: true, message: '请输入编码', trigger: 'blur' }
                ],
            },
        }
    },
    components: {
        Pagination
    },
    created(){
        this.getdata()
    },
    methods:{
        submitForm(editData){
            this.$refs[editData].validate(valid => {
                if (valid) {
                    if(this.detailsFlag){
                        savePayChannel({
                            name:this.editForm.name,
                            commission:this.editForm.commission,
                            status:this.editForm.status,
                            id:this.editForm.id,
                            payCode:this.editForm.payCode,
                        }).then(res=>{
                            if(res.success){
                                this.$message.success("修改成功")
                                this.editForm = {}
                                this.editFormVisible = false
                                this.getdata()
                            }
                        })
                    }else {
                        savePayChannel({
                            name:this.editForm.name,
                            commission:this.editForm.commission,
                            status:0
                        }).then(res=>{
                            if(res.success){
                                this.$message.success("创建成功")
                                this.editForm = {}
                                this.editFormVisible = false
                                this.getdata()
                            }
                        })
                    }
                } else {
                    return false
                }
            })
        },
        openClick(row){
            console.log(row)
            this.$confirm('是否开启'+ row.name + '支付通道，将关闭其他通道', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                savePayChannel({
                    id:row.id,
                    status:1,
                    name:row.name,
                    commission:row.commission,
                    payCode:row.payCode
                }).then(res=>{
                    this.$message.success('修改成功')
                    this.getdata()
                })
            }).catch(() => {         
            });
        },
        addpayment(){
            this.editFormVisible = true
            this.detailsFlag = false
        },  
        handleEdit(row){
            this.detailsFlag = true
            this.editForm = JSON.parse(JSON.stringify(row))
            this.editFormVisible = true
        },
        addClick(){
            this.editFormVisible = true
        },
        closeDialog(){
            this.editFormVisible = false
            this.editForm = {

            }
            this.$refs.editForm.clearValidate()
        },
        addBanner(){
            this.editFormVisible = true
        },
        empty(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.formInline.name = '' 
            this.formInline.phone = ''
            this.getdata()
        },
        search(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.getdata()
        },
        getdata(){
            loadPayChannelList({
                
            }).then(res=>{
                this.listData = res.channels
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/views/SiteManagement/TableFeeManagement/PaymenthCannel.vue